import type { ChatItem } from 'ts-components/PiChat/reducer';
import { toolArgsLabel } from 'ts-components/PiChat/toolLabels';

export type Activity =
  | { kind: 'thinking' }
  | { kind: 'writing'; target: string; size: string }
  | { kind: 'running'; tool: string }
  | { kind: 'responding' }
  | { kind: 'working' };

// Chars of argument JSON (~bytes)
export const formatSize = (chars: number) =>
  chars < 1024 ? `${chars} B` : `${(chars / 1024).toFixed(1)} KB`;

export const showsActivityRow = (activity: Activity | null): boolean =>
  activity?.kind === 'working';

export const selectActivity = (
  items: ChatItem[],
  isStreaming: boolean
): Activity | null => {
  if (!isStreaming) return null;
  const last = items[items.length - 1];
  if (last?.kind === 'tool') {
    if (last.status === 'generating') {
      return {
        kind: 'writing',
        target: toolArgsLabel(last.argsSummary) || last.toolName,
        size: formatSize(last.chars ?? 0),
      };
    }
    if (last.status === 'running') {
      return { kind: 'running', tool: last.toolName };
    }
  }
  if (last?.kind === 'assistant' && !last.done) {
    if (last.text) return { kind: 'responding' };
    if (last.thinking) return { kind: 'thinking' };
  }
  return { kind: 'working' };
};
